import React from 'react';
import Lottie from 'lottie-react';

const PokketLottie = ({ animationPath, width, height, className }) => {
  return (
    <div className={`pokket-lottie ${className || ''}`} style={{ width, height }}>
      <Lottie
        animationData={animationPath}
        loop={true}
        autoplay={true}
      />
    </div>
  );
};

export default PokketLottie; 